import SchemaMarkup from "../Components/SchemaMarkup";

const BlogSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Blog",

    "@id": "https://msayurved.com/blog/#blog",

    "url": "https://msayurved.com/blog/",

    "name": "Ayurveda Blog | Dr. Jigar Gor's Ayurveda",

    "description":
      "Explore Ayurvedic health information, treatment insights, wellness tips, and traditional Ayurvedic knowledge from Dr. Jigar Gor.",

    "publisher": {
      "@id": "https://msayurved.com/#organization"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default BlogSchema;